import { cn } from "./utils";

import type React from "react";

interface Props {
    title: string | React.ReactNode;
    description?: React.ReactNode;
    caption?: string;
    left?: boolean;
    className?: string;
}

const SectionTitle = ({ title, caption, description, left, className }: Props) => {
    return (
        <div
            className={cn(
                "flex flex-col justify-center items-center w-full text-center",
                left && "lg:items-start lg:justify-start lg:text-left",
                className
            )}
        >
            {caption && <p className="font-medium text-cyan-600 dark:text-cyan-500 text-lg">{caption}</p>}
            <h3
                className={cn(
                    "flex justify-between items-center gap-x-4 mb-4 font-semibold text-slate-800 dark:text-slate-200 text-2xl"
                )}
            >
                {title}
            </h3>
            {description && (
                <div className={cn("max-w-lg text-md text-slate-600 dark:text-slate-300 md:text-lg")}>
                    {description}
                </div>
            )}
        </div>
    );
};

export default SectionTitle;
